import gql from 'graphql-tag';

export const CREATE_PURCHASE_ORDER = gql`
    mutation createPurchaseOrderMutation ($input: CreatePurchaseOrderInput!) {
        createPurchaseOrder(input: $input) {
            id
        }
    }
`;
